'use strict';

var util = require('../../util/property-util');

module.exports = /*@ngInject*/ ["HighChartFactory", function (HighChartFactory) {
    var factory = {};
    var labelFunction = function (value, unit) {
        return value + ' ' + unit;
    };

    factory.processTrainData = function (dataMap) {
        var map = new Map();
        dataMap.forEach(function (value, key) {
            switch (key) {
                case "logins":
                    map.set("Logins", {
                        data: basicTransformFunction(dataMap.get("logins"), "value"),
                        axis: HighChartFactory.createYAxis("userAxis", "Black", "users", "right", true, labelFunction)
                    });
                    break;
                case "avgConsumed":
                    map.set("Average Consumption", {
                        data: basicTransformFunction(dataMap.get("avgConsumed"), "value"),
                        axis: HighChartFactory.createYAxis("consumptionAxis", "Black", "GB", "left", true, function (value, unit) {
                            return Math.round(value / (1000 * 1000 * 1000)) + " " + unit;
                        }),
                        formatFunction: function (value, unit) {
                            return Math.round(value / (1000 * 1000 * 1000)) + " " + unit;
                        }
                    });
                    break;
                case "vung":
                    map.set("VU-NG", {
                        data: basicTransformFunction(dataMap.get("vung"),"value"),
                        axis: HighChartFactory.createYAxis("percentAxis", "Black", "%", "left", true, labelFunction)
                    });
                    break;
                case "sla":
                    // create a map entry for every unique sqi value
                    var sqiMap = createSqiMap(dataMap.get("sla"));
                    sqiMap.forEach(function (value, key) {
                        map.set(key, value);
                    });
                    break;
            }
        });
        return map;
    };

    /**
     * Creates the highchart y axes from the data map and adds the axis to the chart object
     * @param chart highcharts chart object
     * @param map   map, the value must contain an axis property
     */
    factory.createAxes = function (chart, map) {
        map.forEach(function (value, key) {
            var usedAxis = value.axis;
            var foundAxis = findYAxis(chart.yAxis, usedAxis.id);
            if (!util.isDefined(foundAxis)) {
                if (usedAxis.labels.myunit.trim() == "%") {
                    usedAxis.min = 0;
                    usedAxis.max = 100;
                } else {
                    usedAxis.min = 0;
                }
                chart.addAxis(usedAxis, false, false, false);
            }
        });
    };

    /**
     * Creates series for every item in the map, also adds the series to the provided highcharts chart object
     * @param chart highcharts chart object
     * @param map   map, the value must contain axis, data properties
     */
    factory.createSeries = function (chart, map) {
        map.forEach(function (value, key) {
            var axis = chart.get(value.axis.id);
            if (axis.options.labelsEnabled) {
                axis.update(
                    {
                        labels: {
                            enabled: true
                        }
                    }, false
                );
            }
            var formatFunction = function (value, unit) {
                return value + ' ' + unit;
            };
            var seriesObject = HighChartFactory.createSeries(value.data, axis, key, util.isDefined(value.formatFunction) ? value.formatFunction : formatFunction);
            seriesObject.dataGrouping = {
                enabled: false
            };
            seriesObject.marker = {radius: 3, enabled: true};
            if (util.isDefined(seriesObject)) {
                chart.addSeries(seriesObject, false, false);
            }
        });
    };

    var createSqiMap = function (array) {
        var map = new Map();
        map.set("SLA 1.1", {
            data: [],
            axis: HighChartFactory.createYAxis("percentAxis", "Black", "%", "left", true, labelFunction)
        });
        map.set("SLA 1.2", {
            data: [],
            axis: HighChartFactory.createYAxis("sqiSecondsAxis", "Black", "s", "left", true, labelFunction)
        });
        map.set("SLA 2", {
            data: [],
            axis: HighChartFactory.createYAxis("percentAxis", "Black", "%", "left", true, labelFunction)
        });

        array.forEach(function (entry) {
            switch (entry.sqiId) {
                case 101:
                    map.get("SLA 1.1").data.push([entry.timestamp, entry.value]);
                    break;
                case 102:
                    map.get("SLA 1.2").data.push([entry.timestamp, entry.value]);
                    break;
                case 103:
                    map.get("SLA 2").data.push([entry.timestamp, entry.value]);
                    break;
            }
        });
        return map;
    };

    var basicTransformFunction = function (array, propertyName) {
        var transformedArray = [];
        array.forEach(function (entry) {
            if (util.isDefined(entry[propertyName])) {
                transformedArray.push([entry.timestamp, entry[propertyName]]);
            }
        });
        return transformedArray;
    };
    return factory;
}];